import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appTrapFocusDirective]'
})
export class TrapFocusDirectiveDirective  implements AfterViewInit{

  constructor(private el: ElementRef) {}
 
  ngAfterViewInit() {
    this.trapFocus(this.el.nativeElement);
  }

  trapFocus(element) {
    element.addEventListener('keydown', (e) => {
      var isTabPressed = e.keyCode === 9; // isTabPressed
      if (!isTabPressed) return;

      const focusableEls1 = element.querySelectorAll(
        'a[href], button, textarea, input[type="text"],' +
        'input[type="radio"], input[type="checkbox"], select'
      );
      const focusableEls = Array.from(focusableEls1)
        .filter( (el: any) => !el.disabled && (el as any).tabIndex !== -1);
      const firstFocusableEl: any = focusableEls[0];  
      const lastFocusableEl: any = focusableEls[focusableEls.length - 1];

      if ( e.shiftKey ) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  }

}
